module.exports = __webpack_public_path__ + "static/media/personJava.2dfa7d56.png";